import { useState } from "react";
import { Link } from "react-router-dom";
// import MapPinBlk from '../../../assets/images/icons/MapPinBlk.svg';
// import ArrowsOutBlk from '../../../assets/images/icons/ArrowsOutBlk.svg';
// import focusBlk from '../../../assets/images/icons/focusBlk.svg';
// import whatsap from '../../../assets/images/icons/whatsap.svg';
// import CallPopup from "../../../Components/ContactPopup/CallPopup";
// import ContactPopup from "../../../Components/ContactPopup/ContactPopup";
import ListThumbSlider from "../../../Components/ListThumbSlider";
import SVGIcons from "../../../assets/images/icons/svgIcons";
import { formURLSlug } from "../../../helpers/helper.functions";
import "./listing.scss";
import S3ImageViewerWithFallback from "../../../Components/awsS3ImageViewer/ImgViewerWithFallback";

const PropertyListGridView = ({ propertyListArr = [] }) => {


  const generateSlug = (title) => formURLSlug(title);

  const [isHovered, setIsHovered] = useState(false);

  return (
    <div className="propertyList-gridView item-listing-wrp gridView-revamp f-wrp">

      <div className="row">
        {propertyListArr.map((element, key) => (
          <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12 each-prop-box" key={key}
            onMouseEnter={() => setIsHovered(key)}
            onMouseLeave={() => setIsHovered(false)}
          >

            <div className="each-property-items property-item-revamp eachGrid-box f-wrp" >
              <Link to={`/property-detail/${generateSlug(element.titleSlug)}`}>
                <div className="propList-bg slider-box f-wrp">
                  {(element.images.length > 0) && <ListThumbSlider isHovered={isHovered === key} images={element.images.filter((i) => i.tempURL).map((img) => img.tempURL)} thumbnails={(element.thumbnails.length > 0) ? element.thumbnails.filter((i) => i && i.tempURL).map((img) => img?.tempURL) : element.images.filter((i) => i && i.tempURL).map((img) => img?.tempURL)} />}
                  {element.permitQRCode ? <span className='absolute-qr-code'><S3ImageViewerWithFallback fileKey={element.permitQRCode} /></span> : null}
                </div>
                <div className="propList-item-blk f-wrp">
                  <div className='each-item-blk'>
                    <p><b>{element.title}</b></p>
                    {element.subTitle && <p className='subTitle'><b>{element.subTitle}</b></p>}
                    <h1>{element.price} AED</h1>
                    <p className='location'><SVGIcons.MapPinIcon /> {element.location}</p>
                    <ul className="detail-list">
                      {element.noOfBedrooms ? <li><span><SVGIcons.BedIcon /> {`${element.noOfBedrooms} ${element.noOfBedrooms === 'Studio' ? '' : 'Beds'}`}</span></li> : null}
                      {element.noOfBathrooms ? <li><span><SVGIcons.BathIcon /> {`${element.noOfBathrooms} Bath`}</span></li> : null}
                      {element.bua ? <li><span><SVGIcons.BuaIcon /> BUA: {`${element.bua} SqFt`}</span></li> : null}
                    </ul>
                  </div>
                  <div className='each-item-blk'>

                    <ul className='card-foot-btn'>
                      <li>
                        <div className="contct-btn-sec f-wrp">
                          <div className="whstapp-btn" onClick={() => (window.location.href = 'tel:+971568816886')} ><SVGIcons.CallIcon /> Call</div>
                        </div>
                      </li>
                      <li>
                        <div className="contct-btn-sec f-wrp">
                          <div className="whstapp-btn" onClick={() => window.open('https://wa.me/971568816886', '_blank')}><SVGIcons.WhatsappIcon /><span>Whatsapp</span></div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </Link>
            </div>

          </div>
        ))}




        {/* {propertyListArr.map((element, key) => (
          <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12" key={key}
            onMouseEnter={() => setIsHovered(key)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <div className="eachGrid-box each-list-blk f-wrp">
              <Link className="absolute-btn" to={`/property-detail/${generateSlug(element.titleSlug)}`} ></Link>
              <div className="img-gallery-wrp slider-box f-wrp">
                {(element.images.length > 0) && <ListThumbSlider isHovered={isHovered === key} images={element.images.filter((i) => i.tempURL).map((img) => img.tempURL)} thumbnails={(element.thumbnails.length > 0) ? element.thumbnails.filter((i) => i && i.tempURL).map((img) => img?.tempURL) : element.images.filter((i) => i && i.tempURL).map((img) => img?.tempURL)} />}
              </div>
              <div className="list-cont-sec f-wrp">
                <div className="prop-detail-wrp f-wrp">
                  <label className="prop-label"><b>AED {element.price}</b></label>
                  <div className="mob-price">{element.location && <span className="location"><img src={MapPinBlk} alt="map-pin" />{element.location}</span>}
                    <b><i>AED</i> {element.price}</b></div>
                  <ul className="flex-list f-wrp">
                    {element.area &&
                      <li>
                        <span className="list-icon"><img src={ArrowsOutBlk} alt="arrowout-icon" /></span>
                        <p>Area: <b>{element.area} sft</b></p>
                      </li>}
                    {element.bua &&
                      <li>
                        <span className="list-icon"><img src={focusBlk} alt="focus-icon" /></span>
                        <p>BUA: <b>{element.bua} sft</b></p>
                      </li>}
                    {element.noOfBedrooms &&
                      <li>
                        <span className="list-icon"><SVGIcons.BedIcon /></span>
                        <p>Beds: <b>{element?.noOfBedrooms}</b></p>
                      </li>}
                    {element.noOfBathrooms &&
                      <li>
                        <span className="list-icon"><SVGIcons.BathIcon /></span>
                        <p>Baths: <b>{element?.noOfBathrooms}</b></p>
                      </li>}
                  </ul>
                </div>
              </div>
              <div className="eachlist-contact-sec f-wrp">
                <ul>
                  <li>
                    <div className="contct-btn-sec f-wrp">
                      <CallPopup />
                    </div>
                  </li>
                  <li>
                    <div className="contct-btn-sec f-wrp">
                      <div className="whstapp-btn" onClick={() => window.open('https://wa.me/971568816886', '_blank')}><img src={whatsap} alt="whatsapp" /><span>WhatsApp</span></div>
                    </div>
                  </li>
                  <li>
                    <div className="contct-btn-sec inquiry f-wrp">
                      <ContactPopup />
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        ))} */}

      </div>
    </div>
  );
};

export default PropertyListGridView;
